import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class Carts extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "Carts";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      name: null,
      description: null,
      total_items: 0,
      total_amount: 0,
      total_subtotal: 0,
      total_taxes: 0,
      total_fees: 0,
      total_discounts: 0,

      tax_rate: 0,
      tax_amount: 0,
      fee_rate: 0,
      fee_amount: 0,
      discount_rate: 0,
      discount_amount: 0,
      items: [],
      taxes: [],
      fees: [],
      discounts: [],
      refunds: [],
      custom_fields: [],
      meta_data: {},
      tags: [],
      notes: [],
      is_inactive: false,

      form_template_id: null,
      form_id: null,
      subscription_id: null,
      donation_id: null,
      installment_id: null,
      recurring_id: null,
      contract_id: null,
      transaction_id: null,
      customer_id: null,

      merchant_id: store.state.ids.merchant_id,
      merchant_settings_id: store.state.ids.merchant_settings_id,
      mid_id: store.state.ids.mid_id,

      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {

    if (data.contact) {
      data.contact = new models.api.Contacts(data.contact);
    }

    if (data.company) {
      data.company = new models.api.Companies(data.company);
    }

    if (data.transactions && data.transactions.length > 0) {
      data.transactions.map(async (transaction) => {
        transaction = new models.api.Transactions(transaction);
      });
    }

    return data;
  }
}
